import { createContext } from "react";
import type { GetBookmarksByPublicationOutput } from "../../../../../api/src/types";

type BookmarkContextType = {
  bookmarksByPublication?: GetBookmarksByPublicationOutput;
};

export const BookmarkContext = createContext<BookmarkContextType>({
  bookmarksByPublication: [],
});
